import { Component, OnInit,Inject } from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA,MatSnackBar} from '@angular/material';
import { FormsModule, }   from '@angular/forms';
import { ToastService } from '../../shared/services/toast.service'
import { AuthService } from '../../shared/services/auth/auth.service';
@Component({
  selector: 'app-visitor',
  templateUrl: './visitor.component.html',
  styleUrls: ['./visitor.component.css']
})

export class VisitorComponent implements OnInit {
  // variable
  public visitor={
  fullName:"",
  associateId:"",
  designation:"",
  email:"",
  startDate:new Date(),
  endDate:"",
  role:"Guest",
  status:true,
  id:"",
  isUpdate:false,
  contactNumber:"",
  imageUrl:'uploads/assets/img/profile/blank-profile.png',
}
 

public mask: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<VisitorComponent>,
    public snackBar: MatSnackBar,
    public toastService:ToastService,
    public auth: AuthService,
  ) { }

  ngOnInit() {
    this.mask= this.auth.phoneNumberMaskObject;
  }

  // on precced on confirmation
  proceed() {
    this.visitor.endDate = this.data.group.endDate;
    // this.data.group.Members.push(this.visitor);
    this.toastService.success();
    // this.snackBar.open(`New Visitor '${this.visitor.fullName}' Addded `, "", {duration: 2000,});
    this.dialogRef.close(this.visitor)
  }

  // no action perform
  cancel() {
    this.dialogRef.close()
  }
}
